import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/pos-layout').then((m) => m.PosLayout),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'sale' },
      {
        path: 'sale',
        loadComponent: () => import('./features/pos/pos-home').then((m) => m.PosHome),
      },
      {
        path: 'fiscal-reports',
        loadComponent: () =>
          import('./features/fiscal-reports/fiscal-reports').then((m) => m.FiscalReports),
      },
      {
        path: 'settings',
        loadComponent: () => import('./features/settings/settings').then((m) => m.Settings),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
